import { createRoot } from 'react-dom/client';
import { createElement } from 'react';
import { configureAnalytics, initGtm, initVitals, trackUrl } from '@lingoda/analytics';
import { init as authInit, fetchMe } from '@lingoda/auth';
import { initRequestWebProvider } from '@lingoda/http';
import { startClock } from '@lingoda/clock';
import { initErrorTracker } from '@lingoda/monitor';
import { currentRouteLabel, goTo, history, logoutPath } from '@lingoda/router';
import { initBraze } from '@lingoda/braze-sdk';
import { assert } from '@lingoda/utils';
import { config } from '@lingoda/config';
import { initForceReloadOutdatedVersionOnIdle } from '@lingoda/app-versioning';
import store from './redux';
import Root from './root/Root';
import routes from './routes';

const shouldInitErrorTracker = !!config.sentryFrontendDsn;
if (shouldInitErrorTracker) {
    initErrorTracker({ ...config, sentryDsn: config.sentryFrontendDsn }, history);
}

authInit();
startClock();
initVitals();

initRequestWebProvider({
    onUnauthorized: () => goTo(logoutPath()),
});

window.addEventListener('load', () => {
    initGtm();
    initBraze();

    trackUrl(history.location.pathname, currentRouteLabel(routes));

    history.listen(({ pathname }) => {
        trackUrl(pathname, currentRouteLabel(routes));
    });
});

void initForceReloadOutdatedVersionOnIdle({ history });
void configureAnalytics();

store.dispatch(fetchMe());

const container = document.getElementById('root');
assert(container, 'React mount element not found');
const root = createRoot(container);
root.render(createElement(Root, { history }));
